<p-dialog [(visible)]="showPrintable" [style]="{ width: '100vw' }">
	<div class="d-flex w-100 mx-3">
		<div class="my-auto me-2">
			<p-inputSwitch [(ngModel)]="showTableId"></p-inputSwitch>
		</div>
		<div class="my-auto">Show Table ID</div>
		<div class="ms-auto">
			<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="print()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'print']" size="lg" class="ms-1 me-2"></fa-icon>
						Print
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>
	<div id="printableArea" class="d-flex flex-wrap myDivToPrint">
		<ng-container *ngFor="let link of linkList">
			<div class="d-flex flex-column">
				<qrcode [qrdata]="link.url" width="256" errorCorrectionLevel="'M'"></qrcode>
				<div *ngIf="showTableId" class="display-14 w-100 text-center mb-4">
					{{ link.id }}
				</div>
			</div>
		</ng-container>
	</div>
</p-dialog>
